"use client";

import { useId } from "react";
import { CircleCheck } from "@/components/icons";
import { ProductTypeIcon } from "@/lib/icons/product-icons";
import { cn } from "@/lib/utils";

export const LANDING_PRODUCTS = [
  { slug: "pallets", label: "Pallets" },
  { slug: "gaylord-boxes", label: "Gaylords" },
  { slug: "ibc-totes", label: "IBC totes" },
  { slug: "plastic-drums", label: "Plastic drums" },
  { slug: "metal-drums", label: "Metal drums" },
  { slug: "wood-crates", label: "Wood crates" },
] as const;

export type LandingProductSlug = (typeof LANDING_PRODUCTS)[number]["slug"];

export function LandingProductPicker({
  value,
  onChange,
  className,
}: {
  value: LandingProductSlug;
  onChange: (slug: LandingProductSlug) => void;
  className?: string;
}) {
  const name = useId();
  return (
    <fieldset className={cn("grid grid-cols-3 gap-2", className)}>
      <legend className="sr-only">Product</legend>
      {LANDING_PRODUCTS.map((product) => (
        <label
          key={product.slug}
          className="group relative flex cursor-pointer flex-col items-center gap-1.5 rounded-xl border border-border bg-surface px-1 py-3 text-center text-xs font-medium transition-colors hover:border-brand/60 active:bg-muted has-checked:border-brand has-checked:bg-brand-tint has-checked:font-semibold has-checked:outline has-checked:outline-1 has-checked:-outline-offset-2 has-checked:outline-brand has-focus-visible:ring-3 has-focus-visible:ring-ring motion-reduce:transition-none"
        >
          <input
            type="radio"
            name={name}
            value={product.slug}
            checked={value === product.slug}
            onChange={() => onChange(product.slug)}
            className="sr-only"
          />
          <CircleCheck
            aria-hidden
            className="absolute right-1.5 top-1.5 hidden size-5 fill-brand text-brand-foreground group-has-checked:block"
          />
          <ProductTypeIcon slug={product.slug} size={32} className="size-8" />
          {product.label}
        </label>
      ))}
    </fieldset>
  );
}
